@import '../../style/globals.scss';

.loadingScreen {
    top: 0;
    height: 100%;
    opacity: 1;
    transition: opacity 500ms ease-out, height 0ms linear 500ms;
    user-select: none;

    img {
        pointer-events: none;
    }
}

.hidden {
    opacity: 0;
    pointer-events: none;
}

@keyframes rotate-and-back {
    0%,
    100% {
        transform: rotate(0deg);
    }
    10% {
        transform: rotate(180deg);
        animation-timing-function: ease-in-out;
    }
    50% {
        transform: rotate(180deg);
    }
    60% {
        transform: rotate(0deg);
        animation-timing-function: ease-in-out;
    }
}

.loadingSpinner {
    animation: rotate-and-back 2.2s infinite; /* Total duration: 300ms rotation + 800ms wait + 300ms back rotation + 800ms wait */
}

.backgroundImage {
    background-position: center center;
    background-size: cover;
}

@keyframes fade-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.text {
    position: absolute;
    top: 70%;
    max-width: 400px;
    width: 100%;
    color: white;
    text-align: center;

    .textItem {
        width: 100%;
        position: absolute;
        opacity: 0;
        animation: fade-in-out 21s linear infinite;
        padding: 20px;

        &:nth-child(1) {
            animation-delay: 0s;
        }

        &:nth-child(2) {
            animation-delay: 7s;
        }

        &:nth-child(3) {
            animation-delay: 14s;
        }
    }

    .title {
        display: block;
        font-weight: bold;
        padding-bottom: 10px;
    }

    .subtitle {
        display: block;
        font-style: italic;
    }

    @keyframes fade-in-out {
        0% {
            opacity: 0;
        }
        10% {
            opacity: 0;
        }
        30% {
            opacity: 1;
        }
        40% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
}
